import React, { useEffect, useState } from 'react';
import { obtenerCreditosDetalle } from '../services/iaImagenService';

// Chip compacto que muestra cuántas fotos con IA le quedan al negocio este mes.
// Se refresca cuando cambia `refrescar` (el modal lo incrementa tras generar).
export default function CreditosIABadge({ refrescar = 0 }) {
  const [c, setC] = useState(null);

  useEffect(() => {
    let vivo = true;
    obtenerCreditosDetalle().then((d) => { if (vivo) setC(d); }).catch(() => {});
    return () => { vivo = false; };
  }, [refrescar]);

  if (!c) return null;

  const agotado = c.restantes <= 0;
  const pocas = !agotado && c.restantes <= 3;
  const color = agotado ? '#B91C1C' : pocas ? '#B45309' : 'var(--k-verde,#0D9488)';
  const fondo = agotado ? '#FEF2F2' : pocas ? '#FFFBEB' : '#F0FDFA';
  const borde = agotado ? '#FECACA' : pocas ? '#FDE68A' : '#CCFBF1';

  const texto = agotado
    ? 'Se te acabaron las fotos con IA de este mes'
    : `Te quedan ${c.restantes} de ${c.limite} fotos con IA este mes`;

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '5px', marginTop: '6px',
      padding: '3px 10px', borderRadius: '999px', background: fondo, border: `1px solid ${borde}`,
      color, fontSize: '11.5px', fontWeight: 700, lineHeight: 1.3,
    }}>
      {agotado ? '⚠️' : '✨'} {texto}
    </span>
  );
}
